import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { PARTNERSHIP } from 'dpl/constants/query_params';
import { USER_TYPES } from 'dpl/shared/constants/shared';
import { LETTER_TO_RESPONSIBLE_BREEDERS_PATH } from 'dpl/shared/constants/urls';
import SignupFormContainer from 'dpl/containers/SignupFormContainer';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import { ANALYTICS_EVENTS, ANALYTICS_VIEWS } from 'dpl/constants/analytics';

export default function UserAuthModalBreederSignupFormV2({
  onAuth,
  onLoginClick
}) {
  const partnership = useSelector(state => state.queryParams[PARTNERSHIP]);
  useEffect(() => {
    sendAnalyticsEvent(ANALYTICS_EVENTS.REGISTRATION_MODAL_VIEWED, {
      view: ANALYTICS_VIEWS.BREEDER_SIGN_UP_MODAL
    });
  }, []);
  return (
    <div className="UserAuthModalBreederSignupFormV2 pv10 ph16">
      <div className="UserAuthModalBreederSignupFormV2__form ph2 relative">
        <h6 className="md:font-32 font-28 fw-medium tc lh-title mb2">
          Join as a Breeder
        </h6>
        <p className="secondary font-16 tc mb6">
          We&apos;ll need a few details to get you started. Your information
          stays private.&nbsp;
          <a
            className="underline"
            href={LETTER_TO_RESPONSIBLE_BREEDERS_PATH}
            rel="noopener noreferrer"
            target="_blank"
          >
            Learn more
          </a>
        </p>
        <SignupFormContainer
          onAuth={onAuth}
          userType={USER_TYPES.BREEDER}
          partnership={partnership}
        />
      </div>
      <div className="pv6 tc bt b--light-gray font-16 secondary">
        <span>Already have an account?</span>
        &nbsp;
        <a
          className="underline"
          href="javascript:void(0)"
          onClick={e => {
            e.preventDefault();
            onLoginClick(e);
          }}
        >
          Log in
        </a>
      </div>
    </div>
  );
}

UserAuthModalBreederSignupFormV2.propTypes = {
  onAuth: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired
};
